export type Signatory = {
  signatoryId?: string;
  title: string;
  firstName: string;
  lastName: string;
  email: string;
  hotelId?: number;
  startDate?: string | null;
};

export type SignatoryError = {
  message: string;
  type: SignatoryErrorType;
};

export enum SignatoryErrorType {
  FirstNameEmpty = 'first_name_empty',
  LastNameEmpty = 'last_name_empty',
  EmailEmpty = 'email_empty',
  TitleEmpty = 'title_empty',
  HotelIdMissing = 'hotelId_empty',
  totalEmployeesEmpty = 'total_employees_empty'
}



// WEBPACK FOOTER //
// ./src/app/Classes/Signatory.ts